module.exports = "data:image/webp;base64,UklGRkIAAABXRUJQVlA4TDYAAAAvP8AAEC8wd2Mx/wSSNmwpVukVnzY+gEOAoBCSJOeCwZHEB4gEX+/PswYR/Z8A/2B9qAG7E2U="